import * as classNames from "classnames";
import IEmptyState from "EmptyState";
import { PictureFrameStyle } from "CommonControls/PictureFrameStyle";
import React from 'react';

interface IModalPictureFrameProps {
    pictureUrl: string,
    backgroundColor?: string,
    style: PictureFrameStyle
}

export default class PictureFrame extends React.Component<IModalPictureFrameProps, IEmptyState> {
    constructor(props: IModalPictureFrameProps) {
        super(props);
    }

    public render() {
        return (
            <div className={classNames("picture-frame", {
                "circle-fit": this.props.style == PictureFrameStyle.CircleFit,
                "circle-cover": this.props.style == PictureFrameStyle.CircleCover,
                "original": this.props.style == PictureFrameStyle.Original,
                "fit": this.props.style == PictureFrameStyle.Fit,
                "cover": this.props.style == PictureFrameStyle.Cover,
                "rounded-fit": this.props.style == PictureFrameStyle.RoundedFit,
                "rounded-cover": this.props.style == PictureFrameStyle.RoundedCover,
            })}>
                <div className="content" style={{backgroundColor: this.props.backgroundColor}}>
                    {this.props.style == PictureFrameStyle.Original ?
                        <img src={this.props.pictureUrl}></img>
                        : <div className="picture"
                        style={{backgroundImage : "url(" + this.props.pictureUrl + ")"}} />
                    }
                </div>
            </div>
        );
    }
}